<template>
	<div class="title-container width-100 flex-column pa-4">
		<div class="width-100 display-flex flex-row flex-align-center flex-justify-space-between mb-8">
			{{ entityTitle }} Title
			<AppTooltip :text="'Delete interface title'" :position="'left'">
				<AnemicButton icon x-small rounded width="20" height="20" class="field-action-button" @click="removeTitle">
					<AppIcon :name="'trash'" class="si" />
				</AnemicButton>
			</AppTooltip>
		</div>
		<div class="tile-message" v-if="isWorkflowSidebarTile">Edit title in the first step of the feature</div>
		<template v-else>
			<div class="setting-title">Edit title</div>
			<SettingSwitch noSwitch :title="'Title'" :placeholder="'Type your title here'" :textFieldValue.sync="titleValue" />
		</template>
	</div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import AppTooltip from '@/components/common/AppTooltip';
import SettingSwitch from './WidgetSettings/SettingSwitch';
import { setWidgetTitle } from '@/store/modules/widgetEditor/actions';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { editWorkflow } from '@/store/modules/selectedWorkflow/getters';
import WorkflowService from '@/utils/WorkflowService';
export default {
	name: 'WidgetTitleSettings',
	components: { SettingSwitch, AppTooltip },
	computed: {
		...mapGettersShorthand({ editWorkflow }),
		...mapGetters('selectedNode', ['editNode']),
		...mapGetters('widgetEditor', ['widgetFields', 'editField', 'widgetMetadata', 'widgetTitle']),
		entityTitle() {
			return this.isWorkflowSidebarTile ? 'Tile' : 'Interface';
		},
		isWorkflowSidebarTile() {
			return WorkflowService.isOfTypeTile(this.editWorkflow);
		},
		widgetOptions() {
			return this.widgetMetadata?.options || {};
		},
		titleValue: {
			set(value) {
				const oldTitleOption = cloneDeep(this.widgetOptions.title || {});
				if (
					!this.editNode.node_title ||
					this.widgetTitle === this.editNode.node_title ||
					oldTitleOption.value === this.editNode.node_title
				) {
					this.setParamInEditNode({ key: 'node_title', value });
				}

				oldTitleOption.value = value;
				this[setWidgetTitle.fullPath](value);
				this.setWidgetOption({ key: 'title', value: oldTitleOption });
			},
			get() {
				return this.widgetOptions.title.value || '';
			},
		},
	},
	methods: {
		...mapActions([setWidgetTitle.fullPath]),
		...mapActions('widgetEditor', ['setWidgetOption']),
		...mapActions('selectedNode', ['setParamInEditNode']),
		removeTitle() {
			this.$emit('remove-title');
			const newTitleValue = { ...this.widgetTitle, active: 0 };
			this.setWidgetOption({ key: 'title', value: newTitleValue });
		},
	},
	data: () => ({
		localField: {
			metadata: {
				options: { title: {}, longText: {}, description: {}, required: {}, placeholder: {}, helper_text: {}, prefill: {} },
				style: { background: {}, outline: {} },
			},
		},
	}),
};
</script>
<style scoped lang="scss">
.setting-title {
	font-size: 14px;
	font-weight: normal;
	color: var(--primary-font-color);
}
.title-container {
	height: 55px;
	font-size: 16px;
	font-weight: bold;
	background: transparent;
	color: var(--primary-font-color);
	border-bottom: 1px solid var(--border-color);
	.tile-message {
		font-size: 14px;
		opacity: 0.5;
		font-weight: normal;
		// color: var(--secondary-font-color);
	}
}
</style>
